import { visualAcuityInstruction } from "@constants/instructionConstants";
import { virtualAssistanceVisualAcuityLogmarConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  TestConfiguration,
  TestCategory,
  TestLanguage,
  WaitDuration,
  TestUIConfiguration,
} from "types/testTypes";
import {
  CATEGORY_VERSION_MAP,
  FEATURE_VERSION_MAP,
  TEST_TYPE_VERSION_MAP,
} from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_BINOCULAR_MONOCULAR_BACK2BACK,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  DUMMY_AVAILABLE_TEST_SPECIFIC_CONFIGURATION_OPTIONS,
} from "../configurationHelperConstants";
import { OSS_TUTORIAL_SUPPORTED_LANGUAGES } from "@constants/languageConstants";

export const availableVisualAcuityTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    choices: [
      { value: TestType.Logmar, validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.Logmar] },
      { value: TestType.TumblingE, validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.TumblingE] },
      {
        value: TestType.TumblingEThreshold,
        validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.TumblingEThreshold],
      },
    ],
    isMandatory: true,
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.VisualAcuity],
  },
  eyeConfigurationOptions: { ...AVAILABLE_EYE_OPTIONS_BINOCULAR_MONOCULAR_BACK2BACK },
  languageOptions: {
    choices: OSS_TUTORIAL_SUPPORTED_LANGUAGES,
    validSinceVersion: FEATURE_VERSION_MAP.tutorialMode,
    configurationFieldName: "testLanguage",
  },
  virtualAssistantOptions: { ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS },
  testSpeedOptions: null,
  testSpecificConfigurationOptions: {
    ...DUMMY_AVAILABLE_TEST_SPECIFIC_CONFIGURATION_OPTIONS,
    toggleShowTutorial: {
      configurationFieldName: "showTutorial",
      choices: null,
      validSinceVersion: FEATURE_VERSION_MAP.tutorialMode,
    },
  },
};

export const visualAcuityTestConfiguration: TestConfiguration = {
  name: TestCategory.VisualAcuity,
  testType: TestType.Logmar,
  eyeConfiguration: {
    eyeType: EyeType.BothEye,
    isCalibrationNeeded: true,
    autoPauseForGaze: false,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: TestLanguage.English,
  virtualAssistanceConfig: virtualAssistanceVisualAcuityLogmarConfig,
  isPressToStartEnabled: false,
  extraData: {
    showTutorial: false,
  },
};

export const visualAcuityUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: visualAcuityInstruction,
  isTestOtherEyeOptionPermitted: true,
};
